import Button from "@/shared/form/button";
import { NotificationOutlined } from "@ant-design/icons";
import { useSendUnreadCompanyDocumentNotificationMutation } from "../model/use-send-unread-company-document-notification-mutation";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";

export type NotifyToReadDocumentProps = {
  id: string;
  personIds?: string[];
};

export function NotifyToReadDocumentButton({
  id,
  personIds,
}: NotifyToReadDocumentProps) {
  const t = useDocumentsTranslations();
  const { send, loading } = useSendUnreadCompanyDocumentNotificationMutation();

  return (
    <Button
      type="primary"
      icon={<NotificationOutlined />}
      onClick={() => send(id, personIds)}
      loading={loading}
    >
      {t("Send notification")}
    </Button>
  );
}
